import React from 'react';
import { ApolloError } from '@apollo/client';
import { copyFor } from 'config';
import { Container, InvisibleHeading } from 'styles';
import { ErrorContent } from 'components/errors/content';
import { NotificationRow } from './notification-row';
import { EmptyState } from '../empty-state';
import { Loading } from '../loading';

interface Props {
  notifications?: QueriedNotification[];
  error?: ApolloError;
  loading: boolean;
  isSMB: boolean;
}

const getCopy = copyFor('notifications.currentPastModule');

export const Current = ({ notifications, error, loading, isSMB }: Props) => {
  if (loading) return <Loading />;

  if (error || !notifications)
    return (
      <Container padding="24px" data-testid="error">
        <ErrorContent />
      </Container>
    );

  if (!notifications.length) {
    return <EmptyState tab="current" />;
  }

  return (
    <Container>
      <InvisibleHeading tag="h2">
        {getCopy('accessibleTitles.current')}
      </InvisibleHeading>
      {notifications.map((notification, index) => (
        <NotificationRow
          notification={notification}
          key={notification.id}
          hideTopBorder={index === 0}
          isSMB={isSMB}
        />
      ))}
    </Container>
  );
};
